import Page1Footer from "./page1-footer";
export default Page1Footer;
